module.exports = __webpack_public_path__ + "img/Blog web 1.482e4b9d.png";